module.exports = __webpack_public_path__ + "img/lookbook_10_right.b84c5700.png";